"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMPANY_CATEGORY_SOVI_FORMULA_GROUPS = void 0;
var client_1 = require("@apollo/client");
exports.COMPANY_CATEGORY_SOVI_FORMULA_GROUPS = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query CompanyCategorySoviFormulaGroups {\n    companyCategorySoviFormulaGroups {\n      name\n      id\n      info\n    }\n  }\n"], ["\n  query CompanyCategorySoviFormulaGroups {\n    companyCategorySoviFormulaGroups {\n      name\n      id\n      info\n    }\n  }\n"])));
var templateObject_1;
